/**
 *
 * AudioRecorder
 *
 */

import React, { memo, useEffect } from 'react';
import classNames from 'classnames';

// styles
import './style.scss';

// layout components
import Preloader from 'components/Preloader';
import ErrorBoundary from 'engine/ErrorBoundary';

// assets
import CustomIcons from 'components/CustomIcons';
import { MediaPlayer } from '..';
import { DeleteOutlined } from '@ant-design/icons';
import { appHelper } from 'appCapacitor/helpers';

const AudioRecorder = ({
  loading,
  recorder,
  // default
  className,
  ...rest
}) => {
  const childClassNames = classNames(
    'audio-recorder',
    (recorder?.isRecording || recorder?.audio) && 'full-width',
    recorder?.audio && 'with-media-player',
    className,
  );

  useEffect(() => {
    !recorder?.isRecording  && appHelper.askRecordAudioPermission();
  }, []);

  return (
    <div className={childClassNames} {...rest}>
      <ErrorBoundary>
        {recorder?.audio && (
          <MediaPlayer
            url={window.URL.createObjectURL(recorder?.audio)}
            duration={recorder?.duration}
            type="small"
          />
        )}
        {recorder?.isRecording && !recorder?.audio && (
          <>
            <div className="recording-time">
              <div className="recording-indicator" />
              <span>
                {recorder?.recordingMinutes < 10
                  ? `0${recorder?.recordingMinutes}`
                  : recorder?.recordingMinutes}
              </span>
              <span>:</span>
              <span>
                {recorder.recordingSeconds < 10
                  ? `0${recorder.recordingSeconds}`
                  : recorder.recordingSeconds}
              </span>
            </div>
            <button
              type="button"
              className="stop-button"
              disabled={recorder?.recordingSeconds === 0}
              onClick={() => recorder?.stopRecording()}
            >
              <CustomIcons type="stop" />
            </button>
          </>
        )}
        {!recorder?.isRecording && recorder?.audio && (
          <button
            type="button"
            className="delete-button"
            onClick={() => recorder?.deleteRecording()}
          >
            <DeleteOutlined />
          </button>
        )}
        {!recorder?.isRecording && !recorder?.audio && (
          <>
            {loading && <Preloader size="small" />}
            {!loading && (
              <button
                type="button"
                className="start-button"
                onClick={() => recorder?.startRecording()}
              >
                <CustomIcons type="microphone" />
              </button>
            )}
          </>
        )}
      </ErrorBoundary>
    </div>
  );
};

export default memo(AudioRecorder);
